// Cart Drawer Recommended Products functionality
window.initRecommendedProductsScript = function () {
  // Clean up any previous instances
  if (window.recommendedProductsObservers && Array.isArray(window.recommendedProductsObservers)) {
    window.recommendedProductsObservers.forEach((o) => {
      try {
        o.disconnect();
      } catch (e) {}
    });
  }
  window.recommendedProductsObservers = [];
  if (window.recommendedProductsSliders && Array.isArray(window.recommendedProductsSliders)) {
    window.recommendedProductsSliders.forEach((s) => {
      try {
        s.destroy(true, true);
      } catch (e) {}
    });
  }
  window.recommendedProductsSliders = [];

  const mobileRecommendations = document.querySelector('.cart-drawer__recommended-products-mobile');
  if (mobileRecommendations) {
    mobileRecommendations.addEventListener(
      'click',
      (e) => {
        if (window.innerWidth >= 750) {
          return;
        }
        
        const btn = e.target.closest('.cart-drawer-recommended-products-item__btn');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();

          const productForm = btn.closest('product-form');
          const formEl = productForm && productForm.querySelector('form');

          if (productForm && formEl) {
            customElements.whenDefined('product-form').then(() => {
              if (typeof productForm.onSubmitHandler === 'function') {
                productForm.onSubmitHandler(e);
              } else if (typeof formEl.requestSubmit === 'function') {
                formEl.requestSubmit();
              } else {
                formEl.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
              }
            });
          }
        }
      },
      true
    );
  }

  document.querySelectorAll('.cart-drawer__recommended-products .product-recommendations').forEach((section) => {
    const root = section.closest('.cart-drawer__recommended-products');
    const isMobile = root && root.classList.contains('cart-drawer__recommended-products-mobile');
    const sliderSelector = isMobile
      ? '.product-recommendations-slider-mobile'
      : '.product-recommendations-slider-desktop';
    const mqlDesktop = window.matchMedia('(min-width: 750px)');

    const initSliders = () => {
      const el = section.querySelector(sliderSelector);
      if (!el) return;
      const opts = isMobile
        ? {
            direction: 'horizontal',
            spaceBetween: 8,
            slidesPerView: 'auto',
            mousewheel: false,
            freeMode: true,
            preventClicks: false,
            preventClicksPropagation: false,
            touchStartPreventDefault: false,
            slidesOffsetBefore: 16
          }
        : {
            direction: 'vertical',
            spaceBetween: 8,
            slidesPerView: 'auto',
            mousewheel: true,
            draggable: true,
            grabCursor: true
          };
      const inst = new Swiper(el, opts);

      if (isMobile) {
        el.addEventListener(
          'click',
          (e) => {
            if (window.innerWidth >= 750) {
              return;
            }
            
            const btn = e.target.closest('.cart-drawer-recommended-products-item__btn');
            if (btn) {
              e.preventDefault();
              e.stopPropagation();

              const productForm = btn.closest('product-form');
              const formEl = productForm && productForm.querySelector('form');

              if (productForm && formEl) {
                customElements.whenDefined('product-form').then(() => {
                  if (typeof productForm.onSubmitHandler === 'function') {
                    productForm.onSubmitHandler(e);
                  } else if (typeof formEl.requestSubmit === 'function') {
                    formEl.requestSubmit();
                  } else {
                    formEl.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                  }
                });
              }
            }
          },
          true
        );
      }

      window.recommendedProductsSliders.push(inst);
    };

    const handleIntersection = (entries, observer) => {
      const loaderContainer = section.querySelector('.product-recommendations__loading');
      const loader = section.querySelector('.product-recommendations__loading .loading__spinner');
      if (loaderContainer) loaderContainer.classList.remove('hidden');
      if (loader) loader.classList.remove('hidden');
      if (!entries[0].isIntersecting) return;
      if (section.dataset.loading === 'true') return;

      observer.unobserve(section);
      section.dataset.loading = 'true';

      const url = section.dataset.url;
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recSection = html.querySelector('.product-recommendations');
          const newSlider = recSection && recSection.querySelector(sliderSelector);
          const current = section.querySelector(sliderSelector);
          if (newSlider && current) {
            if (loaderContainer) loaderContainer.classList.add('hidden');
            if (loader) loader.classList.add('hidden');


            current.innerHTML = newSlider.innerHTML;
            initSliders();
          } else {
            setTimeout(()=>{
              if (loaderContainer) loaderContainer.classList.add('hidden');
              if (loader) loader.classList.add('hidden');
            }, 600)
          }
          section.dataset.loading = 'false';
        })
        .catch((e) => {
          setTimeout(()=>{
            if (loaderContainer) loaderContainer.classList.add('hidden');
          }, 600)
          section.dataset.loading = 'false';
        });
    };

    const initialLoader = section.querySelector('.product-recommendations__loading');
    const initialSpinner = section.querySelector('.product-recommendations__loading .loading__spinner');
    if (initialLoader) initialLoader.classList.add('hidden');
    if (initialSpinner) initialSpinner.classList.add('hidden');

    const isHidden = !(section.offsetWidth || section.offsetHeight || section.getClientRects().length);
    const viewportMatchesThisSection = (isMobile && !mqlDesktop.matches) || (!isMobile && mqlDesktop.matches);
    if (!isHidden && viewportMatchesThisSection) {
      initSliders();
    }
    if (viewportMatchesThisSection) {
      const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
      observer.observe(section);
      window.recommendedProductsObservers.push(observer);
    }
  });
};

// Function to handle recommended products button clicks
window.handleRecommendedProductClick = function(button) {
  const variantId = button.getAttribute('data-variant-id');
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', '1');
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
    const sections = cartDrawer.getSectionsToRender().map(section => section.id);
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);
  }
  
  const config = {
    method: 'POST',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  };
  
  fetch('/cart/add.js', config)
    .then(response => response.json())
    .then(data => {
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(data);
      } else {
        const sectionsToUpdate = ['cart-drawer', 'cart-icon-bubble'];
        const sectionsUrl = window.location.pathname;
        
        fetch(`${sectionsUrl}?sections=${sectionsToUpdate.join(',')}`)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            
            const newCartDrawer = doc.querySelector('cart-drawer');
            if (newCartDrawer && cartDrawer) {
              cartDrawer.innerHTML = newCartDrawer.innerHTML;
            }
            
            const cartIconBubble = document.querySelector('cart-icon-bubble');
            const newCartIconBubble = doc.querySelector('cart-icon-bubble');
            if (cartIconBubble && newCartIconBubble) {
              cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
            }
          })
          .catch(error => {
            console.error('Error fetching cart sections:', error);
          });
      }
      
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      
      document.dispatchEvent(new CustomEvent('cart:updated', { 
        bubbles: true, 
        detail: { cartData: data } 
      }));
      
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        if (typeof cartDrawer.updateCart === 'function') {
          cartDrawer.updateCart();
        }
      }
    })
    .catch(error => {
      console.error('Direct AJAX error:', error);
    });
};

// Event listeners setup
document.addEventListener('DOMContentLoaded', () => {
  if (typeof window.initRecommendedProductsScript === 'function') {
    window.initRecommendedProductsScript();
  }
});

if (!window.recoReinitHandlersAdded) {
  window.recoReinitHandlersAdded = true;
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (typeof window.initRecommendedProductsScript === 'function') {
        window.initRecommendedProductsScript();
      }
    }, 200);
  });
  document.addEventListener('cart:refresh', () => {
    if (typeof window.initRecommendedProductsScript === 'function') {
      window.initRecommendedProductsScript();
    }
  });

  if (!window.recoClickHandlerAdded) {
    window.recoClickHandlerAdded = true;
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest('.cart-drawer-recommended-products-item__btn');
        if (!btn) return;
        if (!btn.closest('.cart-drawer__recommended-products')) return;
        
        const isMobileBtn = btn.closest('.cart-drawer__recommended-products-mobile');
        if (isMobileBtn && window.innerWidth >= 750) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        const productForm = btn.closest('product-form');
        const formEl = productForm && productForm.querySelector('form');
        if (!productForm || !formEl) return;

        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

        const variantId = btn.getAttribute('data-variant-id');
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          formData.append('sections', sections.join(','));
          formData.append('sections_url', window.location.pathname);
        }
        
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        };
        
        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then((data) => {
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            } else {
              const sectionsToUpdate = ['cart-drawer', 'cart-icon-bubble'];
              const sectionsUrl = window.location.pathname;
              
              fetch(`${sectionsUrl}?sections=${sectionsToUpdate.join(',')}`)
                .then((response) => response.text())
                .then((html) => {
                  const parser = new DOMParser();
                  const doc = parser.parseFromString(html, 'text/html');
                  
                  const newCartDrawer = doc.querySelector('cart-drawer');
                  if (newCartDrawer && cartDrawer) {
                    cartDrawer.innerHTML = newCartDrawer.innerHTML;
                  }
                  
                  const cartIconBubble = document.querySelector('cart-icon-bubble');
                  const newCartIconBubble = doc.querySelector('cart-icon-bubble');
                  if (cartIconBubble && newCartIconBubble) {
                    cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
                  }
                })
                .catch((error) => {
                  console.error('Error fetching cart sections:', error);
                });
            }
            
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                bubbles: true,
                detail: { cartData: data },
              })
            );
            
            if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              if (typeof cartDrawer.updateCart === 'function') {
                cartDrawer.updateCart();
              }
            }
          })
          .catch((error) => {
            console.error('Direct AJAX error:', error);
          });
      },
      true
    );
  }
}
